const LvGensetFormFields = {
    id: "id",
    frequency: "frequency",
    ratedVoltage: "ratedVoltage",
    ratedPower: "ratedPower",
    ratedPf: "ratedPf",
    ratedXd: "ratedXd"
}

export default LvGensetFormFields;